/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 * 
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
  from '@thd-olt-component-react/fusion-utils';

  









const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
}

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  



// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
    components.forEach((com, index) => {
      // eslint-disable-next-line no-param-reassign
      com.props = hydratedProps[index]
    });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
        (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? "0"
      );

  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  


  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};